const SUPPORTED_LANGUAGES = new Set([
  'zh-CN',
  'zh-HK',
  'en',
  'ja',
  'ko',
  'de',
  'fr',
  'it',
  'ar',
  'es',
])

export function normalizeAnnouncementLanguage(locale) {
  if (locale === 'zh') return 'zh-CN'
  if (locale === 'hk') return 'zh-HK'
  return SUPPORTED_LANGUAGES.has(locale) ? locale : 'en'
}

export function resolveAnnouncement(value) {
  if (!value || value.enabled === false) return null
  const title = String(value.title || '').trim()
  const content = String(value.content || '').trim()
  if (!title || !content) return null
  return {
    language: normalizeAnnouncementLanguage(value.language),
    title,
    content,
  }
}

export function getAnnouncementTickerText(announcement) {
  const content = String((announcement && announcement.content) || '')
    .replace(/\s+/g, ' ')
    .trim()
  if (content) return content
  return String((announcement && announcement.title) || '').trim()
}
